import React from 'react';
import { Button, ButtonGroup, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ArrowForward } from '@mui/icons-material';
import i18n from '../../i18n';

function PrivacyPolicy() {
    return (
        <Container>
            <Typography align={'justify'}>
                <Typography variant="h4" gutterBottom align={'center'} mt={5}>
                    Privacy Policy
                </Typography>

                {/* TODO add privacy policy */}
            </Typography>

            <ButtonGroup
                sx={{
                    marginTop: 5,
                    marginBottom: 5,
                    justifyContent: 'space-between'
                }}
                variant="outlined"
                color="primary"
            >
                <Button
                    component={Link}
                    to="/login"
                    startIcon={<ArrowBackIcon />}
                >
                    {i18n.t('common.back')}
                </Button>
                <Button
                    component={Link}
                    to="/docs/tos"
                    endIcon={<ArrowForward />}
                >
                    {i18n.t('common.tos')}
                </Button>
            </ButtonGroup>
        </Container>
    );
}
export default PrivacyPolicy;
